var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class PdfField {
  constructor(_data) {
    /**
     */
    __publicField(this, "Name");
    /**
     */
    __publicField(this, "Type");
    /**
     */
    __publicField(this, "Values");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof PdfField
     */
    __publicField(this, "$type", "V1.DocumentTemplates.PdfField");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Name = _data["Name"];
      this.Type = _data["Type"];
      if (_data["Values"] && _data["Values"].constructor === Array) {
        this.Values = [];
        for (let item of _data["Values"]) {
          this.Values.push(item);
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Name"] = this.Name;
    _data["Type"] = this.Type;
    if (this.Values && this.Values.constructor === Array) {
      _data["Values"] = [];
      for (let item of this.Values) {
        _data["Values"].push(item);
      }
    }
    return _data;
  }
}
